













import { Component, Prop, Vue } from "vue-property-decorator";
import LiveSwitcherIcon from '../../../../assets/svg/live-switcher-icon.svg';

@Component({
  name: "LiveSwitcher",
  components: { LiveSwitcherIcon }
})
export default class LiveSwitcher extends Vue {
  @Prop({default: false}) value: boolean;
  @Prop({default: false}) joined: boolean;
  @Prop({default: false}) disabled: boolean;
  
  id = '';
  
  mounted() {
    this.id = 'ls_' + Math.random().toString(36).substr(2, 9);
  }

  onInput(event: any) {
    this.$emit('input', event.target.checked);
    this.$emit('changed', event.target.checked);
  }
}
